import { useEffect } from 'react';
import { useFormikContext } from 'formik';

interface FormValues {
  Dinheiro: number | string;
  Pix: number | string;
  vlrDeposito: number | string;
  VlrCDebito1: number | string;
  VlrCDebito2: number | string;
  VlrCCredito1: number | string;
  VlrCCredito2: number | string;
  Totalizador: number | string;
  [key: string]: any; 
}

const AutoCalculator = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  // --- Função auxiliar para garantir que seja número ---
  const parseMoney = (value: number | string): number => {
    if (typeof value === 'number') return value;
    if (!value) return 0;
    // Se vier como string formatada "R$ 1.000,00", limpa tudo
    const cleanString = value.toString().replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(cleanString) || 0;
  };

  // --- Função para formatar de volta para string ---
  const formatMoney = (value: number): string => {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  useEffect(() => {
    const dinheiro = parseMoney(values.Dinheiro);
    const pix = parseMoney(values.Pix);
    const deposito = parseMoney(values.vlrDeposito);
    const debito1 = parseMoney(values.VlrCDebito1);
    const debito2 = parseMoney(values.VlrCDebito2);
    const credito1 = parseMoney(values.VlrCCredito1);
    const credito2 = parseMoney(values.VlrCCredito2);

    const soma = dinheiro + pix + deposito + debito1 + debito2 + credito1 + credito2;
    const totalAtual = parseMoney(values.Totalizador);

    // Só atualiza se houver diferença (com tolerância para float)
    if (Math.abs(soma - totalAtual) > 0.01) {
       setFieldValue('Totalizador', formatMoney(soma));
    }

  }, [values.Dinheiro, values.Pix, values.vlrDeposito, values.VlrCDebito1, values.VlrCDebito2, values.VlrCCredito1, values.VlrCCredito2, setFieldValue, values.Totalizador]);

  return null;
};

export default AutoCalculator;